/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementEditMemberResponse } from './MemberManagementEditMemberResponse';

export type MemberManagementEditMemberResponseApiRespoonse = {
    data?: MemberManagementEditMemberResponse;
    status?: MemberManagementEditMemberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementEditMemberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

